import { Box, Button, Card, Flex } from '@chakra-ui/react'
import type {
  InsuranceParamsPoleasGridItem,
  PoleasQuery,
} from 'BrokerTsLib/src/dtos'
import { useSearchParamsStatePersistance } from 'BrokerTsLib/src/hooks/useSearchParamsStatePersistance'
import { createContext, useEffect, useState } from 'react'

import { ImportsList } from '@/containers/poleas/ImportsList'

import type { IPaginationContext } from 'BrokerTsLib/src/interfaces/Pagination/Pagination'
import { DashboardHeader } from '../../containers/dashboard/DashboardHeader'
import { PageToolbar } from '../../containers/PageToolbar'
import { PoleasSearch } from '../../containers/poleas/PoleasSearch'
import { SearchButton } from '../../containers/search/SearchButton'
import { WithAuth } from '../../hoc/WithAuth'
import { useGetAll } from '../../hooks/usePoleas'
import { PageWrapper } from '../../layouts/components/PageWrapper'

export const poleasContext = createContext<IPaginationContext<PoleasQuery>>(
  {} as IPaginationContext<PoleasQuery>,
)

const PoleasImportsPageComponent = () => {
  const [isOpen, setOpen] = useState(true)
  const [allowSelect, setAllowSelect] = useState(false)

  const [currentPage, setCurrentPage] = useState(1)

  const [filter, setFilter] = useSearchParamsStatePersistance<PoleasQuery>({
    listType: 1,
    pageIndex: 1,
    pageSize: 10,
  })

  const { data, mutateAsync: getAllAsync, isPending } = useGetAll()
  const items = data?.data

  const reloadData = () => getAllAsync(filter)

  useEffect(() => {
    setFilter({ ...filter, pageIndex: currentPage })
  }, [currentPage])

  useEffect(() => {
    if (filter.pageSize || (filter.pageSize === 0 && filter.showAllItems)) {
      // nechci spoustet nacitani na pageload 2x
      getAllAsync(filter)
    }
  }, [filter])

  return (
    <PageWrapper
      header={<DashboardHeader title="Importované nabídky" />}
      mainProps={{ sx: { pt: { base: 0, md: 8 }, gap: 4, display: 'grid' } }}
    >
      <PageToolbar
        rightElements={
          <Flex sx={{ gap: 4 }}>
            <Button variant="ghost" onClick={() => setAllowSelect(!allowSelect)}>
              {allowSelect ? 'Zrušit výběr' : 'Hromadný výběr'}
            </Button>
            <SearchButton isOpen={isOpen} toggleOpen={() => setOpen(!isOpen)} />
          </Flex>
        }
      />
      <poleasContext.Provider
        value={{
          loading: isPending,
          totalCount: items?.totalCount ?? 0,
          currentPage,
          pageSize: filter.pageSize ?? 10,
          filter,
          setCurrentPage,
          setPageSize: (size) => setFilter({ ...filter, pageSize: size }),
          updateFilter: setFilter,
          reload: reloadData,
        }}
      >
        {isOpen && <PoleasSearch />}

        <Card>
          <Box
            sx={{
              display: 'grid',
              gap: 8,
              placeItems: 'start',
              justifyItems: 'stretch',
            }}
          >
            <ImportsList
              items={(items?.items as InsuranceParamsPoleasGridItem[]) ?? []}
              withPaginator
              allowSelect={allowSelect}
            />
          </Box>
        </Card>
      </poleasContext.Provider>
    </PageWrapper>
  )
}

export const PoleasImportsPage = WithAuth(PoleasImportsPageComponent)
